import copy from '../copy/en/signing.json' with { type: 'json' };
/**
 * Resume-by-token helpers for the public signer page. The signing request's
 * existing unguessable token is the only handle (`?token=` or `?signingToken=`).
 */

/** Read a resume token from a query string (`?token=` wins over `?signingToken=`). */
export function resolveResumeToken(search: string): string {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const q = new URLSearchParams(raw);
  return (q.get("token") || q.get("signingToken") || "").trim();
}

/** Map a typed session-resume `reason` to a signer-facing sentence. */
export function resumeErrorMessage(reason: unknown, fallback: string): string {
  switch (reason) {
    case "expired":
      return copy.thisSigningSessionHasExpired;
    case "already_signed":
      return copy.thisDocumentHasAlreadyBeenSigned;
    case "wrong_form":
      return copy.thisSigningLinkIsForADifferent;
    case "unknown":
      return copy.thisSigningLinkIsInvalid;
    default:
      return fallback;
  }
}
